import moment from "moment";
import patterndef from "@/vue/assets/pattern_def.json";
import countryCodes from "@/vue/utils/countriesByDialCode.json";

export const PILOT = "pilot";
export const PRODUCTION = "production";

export const formatDate = (datetime) =>
  datetime ? moment.utc(datetime).format("MMM Do YY, h:mm:ss a") : "";

export const localMoment = (date) => moment.utc(date).local();

export function parseJwt(token) {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace("-", "+").replace("_", "/");
  return JSON.parse(window.atob(base64));
}

export async function timeout(ms) {
  await new Promise((resolve) => setTimeout(resolve, ms));
}

export function createValidationData(validationFileData) {
  // create validation data for table from validation csv file and capture unique columns
  let data = {};

  validationFileData.map(function (value, key) {
    console.log(value);

    for (let [k, v] of Object.entries(value)) {
      let newKey = k.replace(/[\. ,:-]+/g, "_").trim();
      if (!data[newKey]) data[newKey] = [];

      if (!v) continue;

      // Don't use validation comments in the final validation object
      if (v.substring(0, 2) === "//") {
        continue;
      }

      if (v.indexOf(">") !== -1) {
        data[newKey].push({
          type: "regex",
          parameters: new RegExp(patterndef[v], "i"),
        });
        continue;
      }

      let [type, value] = v.split(":");
      if (type === "dateFormat") {
        data[newKey].push({
          type: function (cell, value, parameters) {
            if (!value) return true;
            return moment.utc(value, parameters.format).isValid();
          },
          parameters: { format: value },
        });
        continue;
      }

      if (type === "required" && value !== "true") {
        continue;
      }

      data[newKey].push({ type, parameters: value });
    }
  });
  console.log(data);
  return data;
}

export function padPhoneNumber(phoneNumber) {
  if (!phoneNumber || phoneNumber.startsWith("+")) {
    return phoneNumber;
  }

  return `+${phoneNumber}`;
}

export const crudState = () => ({
  loading: false,
  success: null,
  message: null,
});

export const countryCodesAndNames = () => Object.values(countryCodes).flat(1);

export const defaultPagination = () => ({
  page: 0,
  size: 200,
});
